import React from 'react'
import ContentLoader from 'react-content-loader'

const MyLoader = props => (
  <ContentLoader speed={2} width={415} height={700} backgroundColor="#e6e6e6" foregroundColor="#cdcdcd" {...props}>
    <rect x="310" y="5" rx="5" ry="5" width="85" height="85" />
    <rect x="24" y="51" rx="5" ry="5" width="88" height="10" />
    <rect x="24" y="8" rx="5" ry="5" width="205" height="13" />
    <rect x="24" y="32" rx="5" ry="5" width="180" height="10" />
    <rect x="24" y="66" rx="14" ry="14" width="60" height="20" />
    <rect x="0" y="0" rx="5" ry="5" width="400" height="1" />
    <rect x="310" y="193" rx="5" ry="5" width="85" height="85" />
    <rect x="0" y="94" rx="5" ry="5" width="400" height="1" />
    <rect x="24" y="144" rx="5" ry="5" width="88" height="10" />
    <rect x="24" y="101" rx="5" ry="5" width="205" height="13" />
    <rect x="24" y="125" rx="5" ry="5" width="180" height="10" />
    <rect x="24" y="159" rx="14" ry="14" width="60" height="20" />
    <rect x="0" y="187" rx="5" ry="5" width="400" height="1" />
    <rect x="305" y="94" rx="5" ry="5" width="1" height="94" />
    <rect x="24" y="240" rx="5" ry="5" width="88" height="10" />
    <rect x="24" y="197" rx="5" ry="5" width="205" height="13" />
    <rect x="24" y="221" rx="5" ry="5" width="180" height="10" />
    <rect x="24" y="255" rx="14" ry="14" width="60" height="20" />
    <rect x="0" y="283" rx="5" ry="5" width="400" height="1" />
    <rect x="310" y="383" rx="5" ry="5" width="85" height="85" />
    <rect x="24" y="334" rx="5" ry="5" width="88" height="10" />
    <rect x="24" y="291" rx="5" ry="5" width="205" height="13" />
    <rect x="24" y="315" rx="5" ry="5" width="180" height="10" />
    <rect x="24" y="349" rx="14" ry="14" width="60" height="20" />
    <rect x="0" y="377" rx="5" ry="5" width="400" height="1" />
    <rect x="305" y="284" rx="5" ry="5" width="1" height="94" />
    <rect x="24" y="430" rx="5" ry="5" width="88" height="10" />
    <rect x="24" y="387" rx="5" ry="5" width="205" height="13" />
    <rect x="24" y="411" rx="5" ry="5" width="180" height="10" />
    <rect x="24" y="445" rx="14" ry="14" width="60" height="20" />
    <rect x="0" y="473" rx="5" ry="5" width="400" height="1" />
    <rect x="310" y="573" rx="5" ry="5" width="85" height="85" />
    <rect x="24" y="524" rx="5" ry="5" width="88" height="10" />
    <rect x="24" y="481" rx="5" ry="5" width="205" height="13" />
    <rect x="24" y="505" rx="5" ry="5" width="180" height="10" />
    <rect x="24" y="539" rx="14" ry="14" width="60" height="20" />
    <rect x="0" y="567" rx="5" ry="5" width="400" height="1" />
    <rect x="305" y="474" rx="5" ry="5" width="1" height="94" />
    <rect x="24" y="620" rx="5" ry="5" width="88" height="10" />
    <rect x="24" y="577" rx="5" ry="5" width="205" height="13" />
    <rect x="24" y="601" rx="5" ry="5" width="180" height="10" />
    <rect x="24" y="635" rx="14" ry="14" width="60" height="20" />
    <rect x="0" y="663" rx="5" ry="5" width="400" height="1" />
  </ContentLoader>
)

export default MyLoader
